import React, { useState, useEffect } from "react";
import { DateInput, TextInput } from "../components/common/ui/Inputs";
import Button from "../components/common/ui/Button";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication.js";
import Table from "../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import ExcelExport from "../components/common/ui/Export/ExcelExport.jsx";
import {
  authActions,
  connectionRequestActions,
  inmateAction,
  masterActions,
  publicUserActions,
} from "../_store";
import generateXlsx from "../components/common/export/generateXlsx.js";
import { Popup } from "../components/common/ui/NotificationModal/Popup.js";
import CustomLoader from "../components/common/ui/Loader";
import {
  getPastDate,
  getCurrentDate,
  Today,
  MinDate,
} from "../utils/formatTime.js";
import { history } from "../_helpers";
import { fDate } from "./../utils/formatTime";
import { StoredProcedures } from "../_helpers/enumerator";
import { getStoredValue } from "../_helpers/storagehelper.js";
import useManagementUserAccessPermission from "../hooks/useManagementUserAccessPermission.jsx";
import { useNavigate } from "react-router-dom";

function ConnectionRequest() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const userAccessPermission = useSelector(
    (state) => state.auth.managementUserAccessPermission
  );
  const { InmateAccessPermission, PuAccessPermission } = useManagementUserAccessPermission();

  const user = useSelector((x) => x.auth.user);
  const menu_list = useSelector((x) => x.auth.menu_list);
  const { isPageReload: isPageReloading, isDashboardPage, isBacktoDashboard } = useSelector((state) => state.master);

  const [showSearchFields, setShowSearchFields] = useState(false);

  const {
    connectionRequestList,
    approveCRStatus,
    rejectCRStatus,
    crExcelList,
    loading,
    connectionReqSearchData,
    connectionReqSearch
  } = useSelector((state) => state.connectionRequest);

  const { isSignalRData } = useSelector((state) => state.auth);


  useEffect(() => {
    if (commonFacilityCode) {
      let updatedState = { ...connectionReqSearchData };
      updatedState.facilityID = commonFacilityCode;
      updatedState.managementUserID = user?.ManagementUserID;
      dispatch(
        connectionRequestActions?.setConnectionReqSearchData(updatedState)
      );
    }
  }, [commonFacilityCode]);

  const [accessPermission, setaccessPermission] = useState([]);

  // Hide or Show Upload btn
  const ShowButtonApproveReject =
    Array?.isArray(accessPermission) && accessPermission?.length > 0
      ? accessPermission?.some(
        (item) => item?.SubMenuID === 23 && item?.SubMenuActiveStatus === 1
      ) // Review
      : true;

  useEffect(() => {
    if (userAccessPermission.length > 0) {
      setaccessPermission(userAccessPermission);
    }
  }, [userAccessPermission]);

  //Get Management User Access Permission list
  useEffect(() => {
    if (commonFacilityCode === 0) return;
    dispatch(
      authActions?.GetManagementUserAccessPermission({
        ManagementUserID: user?.ManagementUserID,
        ManagementMenuID: 36,
      })
    );
  }, [commonFacilityCode]);

  useEffect(() => {
    dispatch(masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 }));
  }, []);

  useEffect(() => {
    if (commonFacilityCode === 0) return;
    let updatedState = { ...connectionReqSearchData };
    if (isDashboardPage) {
      updatedState.fromDate = "01/01/2017";
      updatedState.facilityID = commonFacilityCode;
      updatedState.pageNo = 1;
      updatedState.rowCountPerPage = 10;
      updatedState.managementUserID = user?.ManagementUserID;
      dispatch(connectionRequestActions?.setConnectionReqSearchData(updatedState));
    }
    const params = {
      ...updatedState,
      facilityID: commonFacilityCode,
    };
    dispatch(connectionRequestActions.LoadConnectionRequestList(params));
  }, [
    commonFacilityCode,
    connectionReqSearchData?.rowCountPerPage,
    connectionReqSearchData?.pageNo,
    isPageReloading, isDashboardPage
  ]);

  useEffect(() => {
    if (crExcelList && crExcelList?.DataList?.length > 0) {
      const title = "Connection_Request_List";
      const generateExcelColumns = [
        "Public User Name",
        "Inmate Resident Id",
        "Inmate Name",
        "Relationship",
        "Facility Code",
        "Invited By Inmate",
        "Connection Status",
        "Request Sent Date",
      ];

      // Formatter for dates
      const dateFormatter = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const CRList = crExcelList?.DataList?.map((obj) => ({
        Public_User_Name: obj.PublicUserName,
        Inmate_Resident_Id: obj.InmateResidentID,
        Inmate_Name: obj.InmateName,
        Relationship: obj.RelationShip,
        Facility_Code: obj.FacilityCode,
        Invited_By_Inmate: obj.InvitedByInmate,
        Connection_Status: obj.ConnectionStatusID === 1 ? "Pending" : "Pending",
        Request_Sent_Date: dateFormatter
          .format(new Date(obj.RequestSentDate))
          .replace(",", ""),
      }));

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(CRList, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(connectionRequestActions.clearDeleteCRExcelList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        showToastNotification("Error generating Excel file:", "error");
      }
    }
  }, [crExcelList]);

  useEffect(() => {
    switch (approveCRStatus?.IsSucceed) {
      case 1:
        dispatch(
          connectionRequestActions.LoadConnectionRequestList(
            connectionReqSearchData
          )
        )
          .then((result) => {
            if (result?.payload?.DataList?.length === 0) {
              const updateTotalRows = {
                ...connectionReqSearchData,
                rowCountPerPage: 10,
                pageNo: 1,
              };

              dispatch(
                connectionRequestActions.setConnectionReqSearchData(
                  updateTotalRows
                )
              );
              dispatch(
                connectionRequestActions.LoadConnectionRequestList(
                  updateTotalRows
                )
              );
            }
          })
          .catch((err) => {
            showToastNotification(
              "Failed to get connection requests list",
              "error"
            );
          });
        showToastNotification(
          "Connection request approved successfully",
          "success"
        );
        dispatch(connectionRequestActions.clearApproveStatus());
        break;

      case -1:
        showToastNotification(
          "Something went wrong. Please try again",
          "error"
        );
        dispatch(connectionRequestActions.clearApproveStatus());

        break;

      case -2:
        showToastNotification(
          "Something went wrong. Please try again",
          "error"
        );
        dispatch(connectionRequestActions.clearApproveStatus());

        break;

      default:
        break;
    }
  }, [approveCRStatus]);

  useEffect(() => {
    switch (rejectCRStatus?.IsSucceed) {
      case 2:
        dispatch(
          connectionRequestActions.LoadConnectionRequestList(
            connectionReqSearchData
          )
        )
          .then((result) => {
            if (result?.payload?.DataList?.length === 0) {
              const updateTotalRows = {
                ...connectionReqSearchData,
                rowCountPerPage: 10,
                pageNo: 1,
              };

              dispatch(
                connectionRequestActions.setConnectionReqSearchData(
                  updateTotalRows
                )
              );
              dispatch(
                connectionRequestActions.LoadConnectionRequestList(
                  updateTotalRows
                )
              );
            }
          })
          .catch((err) => {
            showToastNotification(
              "Failed to get connection requests list",
              "error"
            );
          });
        showToastNotification(
          "Connection request blocked successfully",
          "success"
        );
        dispatch(connectionRequestActions.clearRejectStatus());
        break;

      case -1:
        showToastNotification(
          "Something went wrong. Please try again",
          "error"
        );
        dispatch(connectionRequestActions.clearRejectStatus());

        break;

      case -2:
        showToastNotification(
          "Something went wrong. Please try again",
          "error"
        );
        dispatch(connectionRequestActions.clearRejectStatus());

        break;

      default:
        break;
    }
  }, [rejectCRStatus]);

  //signalR
  useEffect(() => {
    switch (isSignalRData?.type) {
      // case 'Public_Inmate_Connection_Request':
      //   const params = {
      //     ...connectionReqSearchData,
      //     facilityID: commonFacilityCode,
      //     isNoLoading: true
      //   };
      //   dispatch(connectionRequestActions.LoadConnectionRequestList(params));
      //   break;
      case 'Admin_Approve_Connection_Request':
        if (isSignalRData?.message?.PuiConnectionID) {
          const approveConnectionIdToRemove = isSignalRData.message.PuiConnectionID;

          const updatedList = connectionRequestList?.DataList?.filter(
            (item) => item.PUIConnectionID !== approveConnectionIdToRemove
          );

          if (updatedList.length !== connectionRequestList?.DataList?.length) {
            dispatch(
              connectionRequestActions.setConnectionRequestList({
                ...connectionRequestList,
                DataList: updatedList,
                TotalRecordCount: connectionRequestList.TotalRecordCount - 1,
              })
            );

            dispatch(
              masterActions.GetLoadNotificationAlert({
                ManagementUserID: user.ManagementUserID,
                FacilityID: getStoredValue("commonFacilityCode"),
                isNoLoading: true
              })
            ).then((response) => {
              const updatedMenuList =
                getStoredValue("menu_list") || response?.payload;

              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            });
          }
        }
        break;
    }
  }, [isSignalRData]);

  const handlePublicUser = () => {
    history.navigate("/Admin/PublicUserList");
  };
  const handleInmateName = () => {
    history.navigate("/Admin/InmateList");
  };

  const checkPathExists = (ManagementMenuID) => {
    return menu_list?.some(
      (menuItem) => menuItem.ManagementMenuID === ManagementMenuID
    );
  };
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };
  const columns = [
    {
      key: "PublicUserName",
      name: "Public User Name",
      selector: (row) => row.PublicUserName,
      sortable: true,
      cell: (row) => (
        // <div onClick={handlePublicUser} className="Common_Link_Style">
        <div
          // className="Common_Link_Style"
          className={` ${checkPathExists(8) && PuAccessPermission[0]?.SubMenuActiveStatus !== 0
            ? "Common_Link_Style"
            : ""
            }`}
          // ShowLink
          onClick={
            checkPathExists(8) && PuAccessPermission[0]?.SubMenuActiveStatus !== 0
              ? () => handleNavigatePublicInfo(row)
              : undefined
          }
        >
          {row.PublicUserName}
        </div>
      ),
    },
    {
      key: "InmateResidentID",
      name: "Inmate Resident ID",
      selector: (row) => row.InmateResidentID,
      sortable: true,
    },
    {
      key: "InmateName",
      name: "Inmate Name",
      selector: (row) => row.InmateName,
      sortable: true,
      cell: (row) => (
        <div
          className={` ${checkPathExists(7) && InmateAccessPermission[0]?.SubMenuActiveStatus !== 0
            ? "Common_Link_Style"
            : ""
            }`}
          onClick={
            checkPathExists(7) && InmateAccessPermission[0]?.SubMenuActiveStatus !== 0
              ? () => handleNavigateInmateInfo(row)
              : undefined
          }
        >
          {row.InmateName}
        </div>
      ),
    },
    {
      key: "FacilityCode",
      name: "Facility Code",
      selector: (row) => row.FacilityCode,
      sortable: true,
    },
    {
      width: "120px",
      key: "RelationShip",
      name: "Relationship",
      selector: (row) => row.RelationShip,
      sortable: true,
    },
    {
      key: "InvitedByInmate",
      name: "Invited By Inmate",
      selector: (row) => row.InvitedByInmate,
      sortable: true,
    },
    {
      key: "ConnectionStatusID",
      name: "Connection Status",
      selector: (row) => (row.ConnectionStatusID === 1 ? "Pending" : "Pending"),
      sortable: true,
    },
    {
      key: "RequestSentDate",
      name: "Request Sent Date",
      selector: (row) => {
        const date = new Date(row.RequestSentDate);

        // Create an Intl.DateTimeFormat object for custom formatting
        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // 12-hour format (AM/PM)
        };

        // Format the date using the options
        const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
          date
        );

        // Replace the comma with an empty string to remove it
        return formattedDate.replace(",", ""); // "11/07/2024 01:41 AM"
      },
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {formatDate(row?.RequestSentDate)}
          </div>
        </div>
      ),

      sortable: true,
    },
    ShowButtonApproveReject && {
      name: "Action",
      selector: (row) => (
        <div className="d-flex flex-wrap gap-1">
          <Button
            label="Approve"
            type="button"
            onClick={() => handleApprove(row)}
            variant="success"
            status={"success"}
            disabled={false}
            className={
              "btn button-success d-block cursor-pointer connection-btn"
            }
          />
          <Button
            label="Block"
            type="button"
            onClick={() => handleReject(row)}
            variant="danger"
            status={"primary"}
            className={
              "btn button-primary d-block  cursor-pointer connection-btn"
            }
            disabled={false}
          />
        </div>
      ),
      sortable: false,
    },
  ];
  const [linkshow, setLinkshow] = useState(false);
  const handleNavigatePublicInfo = (row) => {
    // if (linkshow === true) return;
    dispatch(masterActions.UpdateisDashboardPage(false));

    if (PuAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "connectionRequest" },
    });
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));

  };

  const handleNavigateInmateInfo = (row) => {
    //if (accessPermission[0]?.SubMenuActiveStatus !== 1) return;
    dispatch(masterActions.UpdateisDashboardPage(false));
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;

    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: {
        inmate: row,
        source: "connectionRequest",
        showTransactionTab: false,
      },
    });
  };
  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    dispatch(
      connectionRequestActions?.setConnectionReqSearchData({
        ...connectionReqSearchData,
        pageNo: value,
      })
    );
  };
  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...connectionReqSearchData };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    dispatch(connectionRequestActions?.setConnectionReqSearchData(search));
    dispatch(
      connectionRequestActions.LoadConnectionRequestList({
        ...connectionReqSearchData,
        facilityID: commonFacilityCode,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const RowsCountPerPage = (value) => {
    dispatch(
      connectionRequestActions?.setConnectionReqSearchData({
        ...connectionReqSearchData,
        rowCountPerPage: value,
        pageNo: 1,
      })
    );
  };
  const hadleSearchChange = (name, e) => {
    let value;

    if (e && e.target) {
      value = e.target.value; // For regular inputs (e.g., text inputs)
    }
    switch (name) {
      case "publicUserLastName":
      case "publicUserFirstName":
      //case "inmateResidentID":
      case "inmateLastName":
      case "inmateFirstName":
        if (value !== "" && value.trim() === "") {
          return;
        }
        dispatch(
          connectionRequestActions?.setConnectionReqSearchData({
            ...connectionReqSearchData,
            [name]: value,
          })
        );
        break;

      case "inmateResidentID":
        // Allow only numbers
        if (!/^\d*$/.test(value)) {
          return; // If non-numeric input, ignore it
        }
        dispatch(
          connectionRequestActions?.setConnectionReqSearchData({
            ...connectionReqSearchData,
            [name]: value,
          })
        );
        break;

      default:
        break;
    }
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);
    // updatedState[name] = date || "";
    let updatedParam = { ...connectionReqSearchData, [name]: date };
    dispatch(
      connectionRequestActions?.setConnectionReqSearchData(updatedParam)
    );
  };
  let updatedState = { ...connectionReqSearchData };
  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedState[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "fromDate") {
      if (
        connectionReqSearchData.toDate &&
        new Date(value) > new Date(connectionReqSearchData.toDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "toDate") {
      if (
        connectionReqSearchData.fromDate &&
        new Date(value) < new Date(connectionReqSearchData.fromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...connectionReqSearchData,
      fromDate:
        fieldName === "fromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : connectionReqSearchData.fromDate, // preserve existing value
      toDate:
        fieldName === "toDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : connectionReqSearchData.toDate, // preserve existing value
    };
    dispatch(
      connectionRequestActions?.setConnectionReqSearchData(updatedParam)
    );
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    let updatedState = {
      ...connectionReqSearchData,
      pageNo: 1,
      rowCountPerPage: 10,
    };
    updatedState.facilityID = commonFacilityCode;
    dispatch(connectionRequestActions.setConnectionReqSearchData(updatedState));
    dispatch(connectionRequestActions.LoadConnectionRequestList(updatedState));
  };

  const handleReset = (e) => {
    e?.preventDefault();
    const reset = {
      facilityID: commonFacilityCode,
      publicUserLastName: "",
      publicUserFirstName: "",
      inmateResidentID: "",
      inmateLastName: "",
      inmateFirstName: "",
      fromDate: getPastDate(6),
      toDate: getCurrentDate(),
      pageNo: 1,
      rowCountPerPage: 10,
      sortField: "RequestSentDate DESC",
    };
    dispatch(connectionRequestActions.LoadConnectionRequestList(reset));
    dispatch(connectionRequestActions.setConnectionReqSearchData(reset));
  };

  const handleApprove = (row) => {
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: 36,
      })
    )
      .then((res) => {
        const shouldEnableBtn =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Review" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableBtn) {
          showToastNotification(
            "Approve option has been disabled by the admin.",
            "error"
          );
          return;
        }

        let param = {
          puiConnectionID: row?.PUIConnectionID,
          managementUserID: user?.ManagementUserID,
        };
        if (param) {
          Popup({
            title: "Message",
            text: `Are you sure you want to Approve?`,
            icon: "info",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            onConfirm: () => {
              dispatch(
                connectionRequestActions.ApproveConnectionRequest(param)
              ).then((x => {
                dispatch(masterActions.GetLoadNotificationAlert({
                  ManagementUserID: user.ManagementUserID,
                  FacilityID: getStoredValue("commonFacilityCode"),
                })
                ).then((response) => {
                  const updatedMenuList =
                    getStoredValue("menu_list") ||
                    response?.payload;
                  if (updatedMenuList) {
                    dispatch(authActions.updateMenuList(updatedMenuList));
                  }
                });
              }))
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName:
                    StoredProcedures?.PublicInmateConnectionUpdateByAdmin,
                  UserAction: `Approved Connection Request (ConnectionRequestID - ${row?.PUIConnectionID})`,
                })
              );
              // const updateTotalRows = {
              //   ...connectionReqSearchData,
              //   rowCountPerPage: 10,
              //   pageNo: 1,
              // };

              // dispatch(
              //   connectionRequestActions.setConnectionReqSearchData(
              //     updateTotalRows
              //   )
              // );
              // dispatch(
              //   connectionRequestActions.LoadConnectionRequestList(
              //     updateTotalRows
              //   )
              // );
              // dispatch(connectionRequestActions.resetConnectionReqSearchData());
            },
          });
        }
      })
      .catch((e) => { });
  };

  const handleReject = (row) => {
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: 36,
      })
    )
      .then((res) => {
        const shouldEnableBtn =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Review" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableBtn) {
          showToastNotification(
            "Reject option has been disabled by the admin.",
            "error"
          );
          return;
        }

        let param = {
          puiConnectionID: row?.PUIConnectionID,
          managementUserID: user?.ManagementUserID,
        };
        if (param) {
          Popup({
            title: "Message",
            text: `Are you sure you want to Block?`,
            icon: "info",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            onConfirm: () => {
              dispatch(connectionRequestActions.RejectConnectionRequest(param)).then((x => {
                dispatch(masterActions.GetLoadNotificationAlert({
                  ManagementUserID: user.ManagementUserID,
                  FacilityID: getStoredValue("commonFacilityCode"),
                })
                ).then((response) => {
                  const updatedMenuList =
                    getStoredValue("menu_list") ||
                    response?.payload;
                  if (updatedMenuList) {
                    dispatch(authActions.updateMenuList(updatedMenuList));
                  }
                });
              }))
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName:
                    StoredProcedures?.PublicInmateConnectionUpdateByAdmin,
                  UserAction: `Blocked Connection Request (Connection RequestId - ${row?.PUIConnectionID})`,
                })
              );

              // const updateTotalRows = {
              //   ...connectionReqSearchData,
              //   rowCountPerPage: 10,
              //   pageNo: 1,
              // };

              // dispatch(
              //   connectionRequestActions.setConnectionReqSearchData(
              //     updateTotalRows
              //   )
              // );
              // dispatch(
              //   connectionRequestActions.LoadConnectionRequestList(
              //     updateTotalRows
              //   )
              // );

              // dispatch(connectionRequestActions.resetConnectionReqSearchData());
            },
          });
        }
      })
      .catch((e) => { });
  };

  const handleClickExcel = () => {
    const updateTotalRows = {
      ...connectionReqSearchData,
      RowCountPerPage: connectionRequestList?.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(
      connectionRequestActions.LoadConnectionRequestList(updateTotalRows)
    );
  };

  if (loading) {
    return <CustomLoader />;
  }
  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const handleBack = () => {
    navigate("/Admin/Dashboard");
  }
  const renderSearch = () => {
    return (
      <form>
        <div className="row mt-3">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="publicUserLastName"
                label="Public User Last Name"
                value={connectionReqSearchData?.publicUserLastName}
                handleChange={(e) => hadleSearchChange("publicUserLastName", e)}
                maxLength={50}
                placeholder="Enter Public User Last Name"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="publicUserFirstName"
                label="Public User First Name"
                value={connectionReqSearchData?.publicUserFirstName}
                handleChange={(e) =>
                  hadleSearchChange("publicUserFirstName", e)
                }
                placeholder="Enter Public User First Name"
                maxLength={50}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateResidentID"
                label="Inmate ID"
                value={connectionReqSearchData?.inmateResidentID}
                handleChange={(e) => hadleSearchChange("inmateResidentID", e)}
                placeholder="Enter Inmate ID"
                maxLength={50}
              //disabled={!commonFacilityCode}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateLastName"
                label="Inmate Last Name"
                value={connectionReqSearchData?.inmateLastName}
                handleChange={(e) => hadleSearchChange("inmateLastName", e)}
                maxLength={50}
                placeholder="Enter Inmate Last Name"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="inmateFirstName"
                label="Inmate First Name"
                value={connectionReqSearchData?.inmateFirstName}
                handleChange={(e) => hadleSearchChange("inmateFirstName", e)}
                maxLength={50}
                placeholder="Enter Inmate First Name"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="From Date"
                name="fromDate"
                value={connectionReqSearchData?.fromDate}
                yearDropDown={true}
                handleChange={(e) => handleDateChange(e, "fromDate")}
                isClearable={connectionReqSearchData?.fromDate ? true : false}
                minDate={new Date(2017, 0, 1)}
                maxDate={
                  connectionReqSearchData?.toDate
                    ? connectionReqSearchData?.toDate
                    : new Date()
                }
                handleBlur={(e) => handleDateBlur(e, "fromDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "fromDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="To Date"
                name="toDate"
                value={connectionReqSearchData?.toDate}
                isClearable={connectionReqSearchData?.toDate ? true : false}
                minDate={
                  connectionReqSearchData?.fromDate
                    ? connectionReqSearchData?.fromDate
                    : new Date(2017, 0, 1)
                }
                maxDate={new Date()}
                handleChange={(e) => handleDateChange(e, "toDate")}
                handleBlur={(e) => handleDateBlur(e, "toDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "toDate")}
              />
            </div>
          </div>
        </div>
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            onClick={handleSearch}
            icon={"search"}
            variant="danger"
            status={"primary"}
            disabled={false}
          />

          <Button
            className="me-2"
            label="Reset"
            type="button"
            onClick={handleReset}
            variant="primary "
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };
  return (
    <div>
      {commonFacilityCode > 0 ? (
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">

            {/* Mobile Only */}
            {isBacktoDashboard && (
              <div className="d-block d-md-none card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
                <div className="d-flex justify-content-end">
                  <Button
                    label="BACK To DashBoard"
                    type="button"
                    className="me-2"
                    onClick={() => handleBack()}
                    variant="danger"
                    status={"primary"}
                    icon={"fa-solid fa-angle-left"}
                    disabled={false}
                  />
                </div>
              </div>
            )}

            {/* <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="form_title_uppercase text-color">
                  Connection Request search
                </h2>
              </div>
            </div> */}
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  Connection Request search
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space ">
                <h2 className="form_title_uppercase text-color">
                  Connection Request search
                </h2>

                {isBacktoDashboard && (
                  <div className="d-flex flex-wrap gap-3">
                    <Button
                      label="BACK To DashBoard"
                      type="button"
                      className=" me-2"
                      onClick={() => handleBack()}
                      variant="danger"
                      status={"primary"}
                      icon={"fa-solid fa-angle-left"}
                      disabled={false}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>

            <div></div>
          </div>

          {commonFacilityCode > 0 ? (
            <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 mb-4">
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 resp-space">
                <h2 className="form_title_uppercase text-color">
                  Connection RequestS LIST
                </h2>
                <div>
                  {connectionRequestList?.DataList?.length > 0 && (
                    <ExcelExport
                      variant="soft-gray"
                      handleExcelExport={handleClickExcel}
                    />
                  )}
                </div>
              </div>
              <Table
                columns={columns}
                data={connectionRequestList?.DataList}
                totalRowCount={connectionRequestList?.TotalRecordCount}
                pagination={true}
                paginationPerPage={connectionReqSearchData?.rowCountPerPage}
                currentPage={connectionReqSearchData?.pageNo}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={RowsCountPerPage}
                onSort={handleSort}
                serverSideSort
                sortColumn={connectionReqSearchData?.sortField?.split(" ")[0]}
                sortDirection={
                  connectionReqSearchData?.sortField?.split(" ")[1]
                }
              />
            </div>
          ) : (
            <h4 className="facility-card">
              Select a Facility Code from the list
            </h4>
          )}
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </div>
  );
}

export default React.memo(ConnectionRequest);
